import { render, staticRenderFns } from "./BySpecialization.vue?vue&type=template&id=07a236c4&"
import script from "./BySpecialization.vue?vue&type=script&lang=js&"
export * from "./BySpecialization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports